// extracted by mini-css-extract-plugin
module.exports = {"image":"CertificateTab_image__1fdrg"};